<template>
    <div v-if="step2FA">
        <div>
            <div class="main">
                <img src="../assets/icons/sms.png" alt="sms logo" width="80" height="80" />
                <p class="sms-title">{{ $t('wallet028') }}</p>
                <i18n path="wallet029" tag="p" class="sms-subtitle">
                    <span class="sms-subtitle2" place="email">{{userData.email}}</span>
                </i18n>
                <div class="fieldset">
                    <label class="box"><input :class="{'sms-digit': true, 'sms-digit-error': wrong2FA}" type="text" placeholder="•" v-model="input1" /></label>
                    <label class="box"><input :class="{'sms-digit': true, 'sms-digit-error': wrong2FA}" type="text" placeholder="•" v-model="input2" /></label>
                    <label class="box"><input :class="{'sms-digit': true, 'sms-digit-error': wrong2FA}" type="text" placeholder="•" v-model="input3" /></label>
                    <label class="box"><input :class="{'sms-digit': true, 'sms-digit-error': wrong2FA}" type="text" placeholder="•" v-model="input4" /></label>
                    <label class="box"><input :class="{'sms-digit': true, 'sms-digit-error': wrong2FA}" type="text" placeholder="•" v-model="input5" /></label>
                    <label class="box"><input :class="{'sms-digit': true, 'sms-digit-error': wrong2FA}" type="text" placeholder="•" v-model="input6" /></label>
                </div>
                <div v-if="wrong2FA" class="error-2fa">{{ $t('wallet031') }}</div>
                <i18n path="wallet030" tag="div" v-if="countInProgress" class="countdown">
                    <span place="timer">{{timer}}</span>
                </i18n>
                <div class="countdown2" v-on:click="resendCode" v-if="!countInProgress">Resend code</div>

                <v-btn class="sms-submit" v-on:click="submitCode">{{ $t('continue') }}</v-btn>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="myprofile-inner-container">
            <div class="success-alert" v-if="bankDetailsUpdatedSuccess">
                Your changes have been saved
            </div>
            <div class="fail-alert" v-if="bankDetailsUpdatedFail">
                There was an error while trying to update your details
            </div>
            <div class="fail-alert" v-if="showAddBillingAddressError">
                You should add a billing address first!
            </div>
            <div class="fail-alert" v-if="bankDetailsUpdatedFail && bankDetailsUpdatedFailErrors.length" style="margin-top: 8px;">
                <div v-for="(error, index) in bankDetailsUpdatedFailErrors" :key="index">{{error}}</div>
            </div>
            <div v-if="!checkBankAccount" class="bank-details-wrapper">
                <v-flex>
                    <span class="myprofile-label">{{ $t('sell9') }} <span>*</span></span>
                    <v-text-field v-model="editBankDetails.beneficiaryName" :rules="[rules.required]" :disabled="true"></v-text-field>
                </v-flex>
                <v-radio-group class="bank-details-radio" v-model="ibanOrAccount">
                    <v-flex>
                        <v-radio
                            label="IBAN *"
                            :value=true
                        ></v-radio>
                        <v-text-field v-model="editBankDetails.iban" :rules="[rules.required, rules.validIBAN]"
                                      placeholder="BGUNCR7000" :disabled="!ibanOrAccount"></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-radio
                            label="Account number *"
                            :value=false
                        ></v-radio>
                        <v-text-field v-model="editBankDetails.accountNumber" :rules="[rules.required, rules.max]"
                                      placeholder="01234567890123456789" :disabled="ibanOrAccount"></v-text-field>
                    </v-flex>
                </v-radio-group>
                <v-flex>
                    <span class="myprofile-label">Swift/ABA <span>*</span></span>
                    <v-text-field v-model="editBankDetails.bicSwift" :rules="[rules.required, rules.swift]"
                                  placeholder="UNCRBGSF"></v-text-field>
                </v-flex>
                <v-flex v-if="country === 'CA'">
                    <span class="myprofile-label">{{ $t('wallet094') }} <span>*</span></span>
                    <v-text-field v-model="editBankDetails.institutionNumber" :rules="[rules.required]"
                                  placeholder="123"></v-text-field>
                </v-flex>
                <v-flex v-if="country === 'CA'">
                    <span class="myprofile-label">{{ $t('wallet095') }} <span>*</span></span>
                    <v-text-field v-model="editBankDetails.branchCode" :rules="[rules.required]"
                                  placeholder="12345"></v-text-field>
                </v-flex>
                <v-flex v-if="country === 'GB'">
                    <span class="myprofile-label">{{ $t('wallet096') }} <span>*</span></span>
                    <v-text-field v-model="editBankDetails.sortCode" :rules="[rules.required]"
                                  placeholder="123456"></v-text-field>
                </v-flex>
                <v-flex class="myacc-email-container">
                    <span class="myprofile-label">{{ $t('sell10') }} <span>*</span></span>
                    <v-text-field v-model="editBankDetails.bankName" :rules="[rules.required]"
                                  placeholder="UniCredit Bulbank"></v-text-field>
                </v-flex>
                <v-flex class="myacc-email-container">
                    <span class="myprofile-label">City of the bank <span>*</span></span>
                    <v-text-field v-model="editBankDetails.city" :rules="[rules.required]"
                                  placeholder="City name here"></v-text-field>
                </v-flex>
                <v-flex class="myacc-email-container">
                    <span class="myprofile-label">{{ $t('wallet096-1') }} <span>*</span></span>
                    <v-text-field v-model="editBankDetails.address" :rules="[rules.required]"
                                  placeholder="Street name here"></v-text-field>
                </v-flex>
                <v-flex v-if="vin_countries.length">
                    <span class="myprofile-label country-label">{{ $t('address15') }} <span>*</span></span>
                    <country-select class="country-select" :whiteList="vin_countries"
                                    :class="countryError ? 'error-msg' : ''" v-model="country" :rules="[rules.required]"
                                    :country="country" placeholder="Choose country"/>
                    <div v-if="countryError" class="v-text-field__details">
                        <div class="v-messages theme--light error--text">
                            <div class="v-messages__wrapper">
                                <div class="v-messages__message">Required.</div>
                            </div>
                        </div>
                    </div>
                </v-flex>
            </div>
            <div v-else class="bank-details-wrapper">
                <v-flex>
                    <span class="myprofile-label">{{ $t('sell9') }} <span>*</span></span>
                    <v-text-field v-model="newBankDetails.beneficiaryName" :disabled="true"></v-text-field>
                </v-flex>
                <v-radio-group class="bank-details-radio" v-model="ibanOrAccount">
                    <v-flex>
                        <v-radio
                            label="IBAN *"
                            :value=true
                        ></v-radio>
                        <v-text-field v-model="newBankDetails.iban" :rules="[rules.required, rules.validIBAN]"
                                      placeholder="BGUNCR7000" :disabled="!ibanOrAccount"></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-radio
                            label="Account number *"
                            :value=false
                        ></v-radio>
                        <v-text-field v-model="newBankDetails.accountNumber" :rules="[rules.required, rules.max]"
                                      placeholder="01234567890123456789" :disabled="ibanOrAccount"></v-text-field>
                    </v-flex>
                </v-radio-group>
                <v-flex>
                    <span class="myprofile-label">Swift/ABA <span>*</span></span>
                    <v-text-field v-model="newBankDetails.bicSwift" :rules="[rules.required, rules.swift]"
                                  placeholder="UNCRBGSF"></v-text-field>
                </v-flex>
                <v-flex v-if="country === 'CA'">
                    <span class="myprofile-label">{{ $t('wallet094') }} <span>*</span></span>
                    <v-text-field v-model="newBankDetails.institutionNumber" :rules="[rules.required]"
                                  placeholder="123"></v-text-field>
                </v-flex>
                <v-flex v-if="country === 'CA'">
                    <span class="myprofile-label">{{ $t('wallet095') }} <span>*</span></span>
                    <v-text-field v-model="newBankDetails.branchCode" :rules="[rules.required]"
                                  placeholder="12345"></v-text-field>
                </v-flex>
                <v-flex v-if="country === 'GB'">
                    <span class="myprofile-label">{{ $t('wallet096') }} <span>*</span></span>
                    <v-text-field v-model="newBankDetails.sortCode" :rules="[rules.required]"
                                  placeholder="123456"></v-text-field>
                </v-flex>
                <v-flex class="myacc-email-container">
                    <span class="myprofile-label">{{ $t('sell10') }} <span>*</span></span>
                    <v-text-field v-model="newBankDetails.bankName" :rules="[rules.required]"
                                  placeholder="UniCredit Bulbank"></v-text-field>
                </v-flex>
                <v-flex class="myacc-email-container">
                    <span class="myprofile-label">City of the bank <span>*</span></span>
                    <v-text-field v-model="newBankDetails.city" :rules="[rules.required]"
                                  placeholder="City name here"></v-text-field>
                </v-flex>
                <v-flex class="myacc-email-container">
                    <span class="myprofile-label">{{ $t('wallet096-1') }} <span>*</span></span>
                    <v-text-field v-model="newBankDetails.address" :rules="[rules.required]"
                                  placeholder="Street name here"></v-text-field>
                </v-flex>
                <v-flex v-if="vin_countries.length">
                    <span class="myprofile-label country-label">{{ $t('address15') }} <span>*</span></span>
                    <country-select class="country-select" :whiteList="vin_countries" v-model="country"
                                    :class="countryError ? 'error-msg' : ''" :rules="[rules.required]"
                                    :country="country" placeholder="Choose country"/>
                    <div v-if="countryError" class="v-text-field__details">
                        <div class="v-messages theme--light error--text">
                            <div class="v-messages__wrapper">
                                <div class="v-messages__message">Required.</div>
                            </div>
                        </div>
                    </div>
                </v-flex>
            </div>
        </div>
        <v-btn v-if="!checkBankAccount" class="submit myprofile-submit" v-on:click="updateBankDetails">{{$t('change-password3')}}</v-btn>
        <div class="reset-btn" v-if="!checkBankAccount" v-on:click="showResetModal = true">{{ $t('reset') }}
            <div class="link-border"></div>
        </div>
        <v-btn v-if="checkBankAccount" class="submit myprofile-submit" v-on:click="addBankDetails">Add bank account</v-btn>

        <v-dialog v-model="showResetModal" max-width="570px">
            <v-card class="reset-changes-modal">
                <div class="warning-icon"></div>
                <v-card-title>Are you sure?</v-card-title>

                <v-card-text class="reset-changes-body">
                    Your changes will be lost, please confirm your intention
                </v-card-text>

                <v-card-actions>
                    <v-btn class="btn-primary btn-reset-proceed" text v-on:click="resetBankDetails">Proceed</v-btn>
                    <v-btn class="btn-secondary btn-reset-cancel" text v-on:click="showResetModal = false">{{
                        $t('cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showConfirmationModal" max-width="500px" persistent>
            <v-card class="bids-offers-modal confirm-address-modal">
                <v-card-title>{{ $t('confirm-address07') }}</v-card-title>
                <v-card-text class="cancel-bid-body">
                    {{ $t('confirm-address08') }}
                </v-card-text>
                <v-card-actions>
                    <v-btn class="btn-primary btn-bid-close" text v-on:click="() => { showConfirmationModal = false }">{{ $t('confirm-address03') }}</v-btn>
                    <v-btn class="btn-primary btn-bid-proceed" text v-on:click="secondStep">{{ $t('confirm-address04') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showConfirmationModal2" max-width="500px" persistent>
            <v-card class="bids-offers-modal confirm-address-modal">
                <v-card-title>{{ $t('confirm-address07') }}</v-card-title>
                <v-card-text class="cancel-bid-body">
                    {{ $t('confirm-address08') }}
                </v-card-text>
                <v-card-actions>
                    <v-btn class="btn-primary btn-bid-close" text v-on:click="() => { showConfirmationModal2 = false }">{{ $t('confirm-address03') }}</v-btn>
                    <v-btn class="btn-primary btn-bid-proceed" text v-on:click="secondStep2">{{ $t('confirm-address04') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters, mapActions, mapState} from 'vuex';
    import {AUser} from '@/store/actions';
    import {GUser, GCommon} from '@/store/getters';
    import IBAN from 'iban';

    export default {
        name: "BankDetails",
        components: {IBAN},
        data() {
            return {
                newBankDetails: {
                    countryId: null,
                    country: "",
                    iban: "",
                    bicSwift: "",
                    beneficiaryName: "",
                    bankName: "",
                    city: "",
                    accountNumber: "",
                    accountType: 5,
                    address: ""
                },
                vin_countries: [],
                ibanError: false,
                branchCodeError: false,
                showConfirmationModal: false,
                showConfirmationModal2: false,
                showAddBillingAddressError: false,
                instNumberError: false,
                ibanOrAccount: false,
                countryMap: [],
                showResetModal: false,
                bankDetailsUpdatedSuccess: false,
                bankDetailsUpdatedFail: false,
                bankDetailsUpdatedFailErrors: [],
                rules: {
                    required: value => !!value || 'Required.',
                    validIBAN: value => IBAN.isValid(value) || 'Invalid IBAN',
                    max: value => !value.length ? true : value.length < 21 || 'Max 20 characters',
                    swift: value => !value.length ? true : (value.length > 7 && value.length < 12) || 'Min 8 and max 11 characters'
                },
                country: null,
                countryError: false,
                countInProgress: false,
                step2FA: false,
                wrong2FA: false,
                timer: 120,
                input1: '',
                input2: '',
                input3: '',
                input4: '',
                input5: '',
                input6: '',
            }
        },
        computed: {
            ...mapGetters({
                bankDetails: GUser.GET_BANK_DETAILS,
                countriesList: GCommon.GET_COUNTRIES_LIST,
                userData: GUser.GET_USER_DATA,
                addressesList: GUser.GET_ADDRESSES
            }),
            disableSubmitCodeBtn() {
                let _disabled = false

                if (this.input1 === '' || this.input2 === '' || this.input3 === '' || this.input4 === '' || this.input5 === '' || this.input6 === '' || this.wrong2FA) {
                    _disabled = true
                }

                return _disabled
            },
            editBankDetails() {
                return Object.assign({}, this.bankDetails);
            },
            checkBankAccount() {
                if (typeof this.bankDetails.countryId !== 'undefined') {
                    let bankCtrl = this;
                    for (let key in this.countries) {
                        if (this.countries.hasOwnProperty(key)) {
                            if (this.countries[key].id === this.bankDetails.countryId.toString()) {
                                bankCtrl.country = key;
                                break;
                            }
                        }
                    }
                }

                if (typeof this.bankDetails.countryId !== 'undefined') {
                    this.ibanOrAccount = (typeof this.bankDetails.iban !== 'undefined' && this.bankDetails.iban !== '');
                }

                this.addressesList.forEach(element => {
                    if (element.type === 1 || element.type === 3) {
                        this.newBankDetails.beneficiaryName = element.firstName + ' ' + element.lastName
                    }
                });

                if (!this.addressesList.length) {
                    this.showAddBillingAddressError = true
                }

                return typeof this.bankDetails.iban == 'undefined';
            },
            ...mapState({
                countries: state => state.countries
            })
        },
        methods: {
            addBankDetails() {
                this.bankDetailsUpdatedFail = false;

                if (this.newBankDetails.bankName && this.newBankDetails.beneficiaryName && (this.newBankDetails.iban || this.newBankDetails.accountNumber)) {
                    if (!this.country) {
                        this.countryError = true;
                        return;
                    }

                    if (this.country !== 'GB' && this.country !== 'CA') {
                        if (this.newBankDetails.bicSwift === '') {
                            alert('Swift is not valid!');
                            return;
                        }
                    }

                    if (this.newBankDetails.iban && !IBAN.isValid(this.newBankDetails.iban)) {
                        alert('IBAN is not valid!');
                        return;
                    }

                    if (this.country === 'CA') {
                        if (this.newBankDetails.institutionNumber === '' || this.newBankDetails.branchCode === '') {
                            return
                        }
                    }

                    if (this.ibanOrAccount) {
                        this.newBankDetails.accountNumber = '';
                        this.newBankDetails.accountType = 1
                    } else {
                        this.newBankDetails.iban = '';
                    }

                    if (this.country === 'GB') {
                        this.newBankDetails.accountType = 2
                    } else if (this.country === 'CA') {
                        this.newBankDetails.accountType = 4
                    } else if (this.country === 'US') {
                        this.newBankDetails.accountType = 3
                    }

                    this.countryError = false;
                    let allCountries = this.countries;

                    if (typeof allCountries[this.country] !== 'undefined') {
                        this.newBankDetails.countryId = allCountries[this.country].id;
                        this.newBankDetails.country = allCountries[this.country].value;
                    }

                    this.showConfirmationModal = true;
                }
            },
            secondStep() {
                this.$store.dispatch(AUser.VALIDATE_BANK_DETAILS, this.newBankDetails).then(() => {
                    this.$store.dispatch(AUser.GET_2FA_CONFIRMED).then((res) => {
                        this.showConfirmationModal = false;
                        if (!res) {
                            this.$store.dispatch(AUser.GET_2FA_EMAIL).then(() => {
                                this.step2FA = true;

                                window.scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                });

                                this.startTimer();

                                setTimeout(() => {
                                    this.updateSmsBoxes()
                                }, 300)
                            })
                        } else {
                            this.$store.dispatch(AUser.ADD_BANK_DETAILS, this.newBankDetails).then(() => {
                                this.bankDetailsUpdatedSuccess = true;
                                let updateDetailsCtrl = this;

                                setTimeout(function () {
                                    updateDetailsCtrl.bankDetailsUpdatedSuccess = false;
                                }, 5000);
                                this.$store.dispatch(AUser.GET_BANK_DETAILS);
                            }).catch(() => {
                                this.bankDetailsUpdatedFail = true;
                                let updateDetailsCtrl = this;

                                setTimeout(function () {
                                    updateDetailsCtrl.bankDetailsUpdatedFail = false;
                                }, 5000)
                            });
                        }
                    });
                }).catch(err => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });

                    this.bankDetailsUpdatedFail = true;

                    Object.keys(err.data.errors).forEach(key => {
                        const value = err.data.errors[key];
                        this.bankDetailsUpdatedFailErrors.push(value[0])
                    });
                })
            },
            updateBankDetails() {
                this.bankDetailsUpdatedFail = false;

                if (this.editBankDetails.bankName && (this.editBankDetails.iban || this.editBankDetails.accountNumber)) {
                    if (!this.country) {
                        this.countryError = true;
                        return;
                    }

                    if (this.country !== 'GB' && this.country !== 'CA') {
                        if (this.editBankDetails.bicSwift === '') {
                            alert('Swift is not valid!');
                            return;
                        }
                    }

                    if (this.editBankDetails.iban && !IBAN.isValid(this.editBankDetails.iban)) {
                        alert('IBAN is not valid!');
                        return;
                    }

                    if (this.country === 'GB') {
                        if (this.editBankDetails.iban === '' && (this.editBankDetails.sortCode === '' || this.editBankDetails.sortCode === null)) {
                            alert('Sort code is not valid!');
                            return;
                        }
                    }

                    if (this.country === 'CA') {
                        if (this.editBankDetails.institutionNumber === '' || this.editBankDetails.institutionNumber === null || this.editBankDetails.branchCode === '' || this.editBankDetails.branchCode === null) {
                            if (this.editBankDetails.institutionNumber === '' || this.editBankDetails.institutionNumber === null) {
                                alert('Institution number is required!');
                                return
                            }
                            if (this.editBankDetails.branchCode === '' || this.editBankDetails.branchCode === null) {
                                alert('Branch code is required!');
                                return
                            }
                        }
                    }

                    if (this.ibanOrAccount) {
                        this.editBankDetails.accountNumber = '';
                        this.editBankDetails.accountType = 1;
                    } else {
                        this.editBankDetails.iban = '';
                    }

                    if (this.country === 'GB') {
                        this.editBankDetails.accountType = 2
                    } else if (this.country === 'CA') {
                        this.editBankDetails.accountType = 4
                    } else if (this.country === 'US') {
                        this.editBankDetails.accountType = 3
                    }

                    this.editBankDetails.countryId = this.countries[this.country].id;
                    this.editBankDetails.country = this.countries[this.country].value;

                    this.showConfirmationModal2 = true;
                }
            },
            secondStep2() {
                this.$store.dispatch(AUser.VALIDATE_BANK_DETAILS, this.editBankDetails).then(() => {
                    this.$store.dispatch(AUser.GET_2FA_CONFIRMED).then((res) => {
                        this.showConfirmationModal2 = false;

                        if (!res) {
                            this.$store.dispatch(AUser.GET_2FA_EMAIL).then(() => {
                                this.step2FA = true;

                                window.scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                });

                                this.startTimer();

                                setTimeout(() => {
                                    this.updateSmsBoxes()
                                }, 300)
                            })
                        } else {
                            this.$store.dispatch(AUser.UPDATE_BANK_DETAILS, this.editBankDetails).then(() => {
                                this.bankDetailsUpdatedSuccess = true;
                                let updateDetailsCtrl = this;

                                setTimeout(function () {
                                    updateDetailsCtrl.bankDetailsUpdatedSuccess = false;
                                }, 5000)
                                this.$store.dispatch(AUser.GET_BANK_DETAILS);
                            }).catch(() => {
                                this.bankDetailsUpdatedFail = true;
                                let updateDetailsCtrl = this;

                                setTimeout(function () {
                                    updateDetailsCtrl.bankDetailsUpdatedFail = false;
                                }, 5000)
                            });
                        }
                    })
                }).catch(err => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });

                    this.bankDetailsUpdatedFail = true;

                    Object.keys(err.data.errors).forEach(key => {
                        const value = err.data.errors[key];
                        this.bankDetailsUpdatedFailErrors.push(value[0])
                    });
                })
            },
            submitCode() {
                let updateDetailsCtrl = this;
                let smsCode = this.input1 + this.input2 + this.input3 + this.input4 + this.input5 + this.input6;

                this.$store.dispatch(AUser.SET_2FA_CODE, { code: smsCode }).then((res) => {
                    if (res.succeeded) {
                        if (!this.checkBankAccount) {
                            this.$store.dispatch(AUser.UPDATE_BANK_DETAILS, updateDetailsCtrl.editBankDetails).then(() => {
                                updateDetailsCtrl.step2FA = false;
                                updateDetailsCtrl.bankDetailsUpdatedSuccess = true;
                                clearInterval(updateDetailsCtrl.interval);

                                setTimeout(function () {
                                    updateDetailsCtrl.bankDetailsUpdatedSuccess = false;
                                }, 5000)
                                updateDetailsCtrl.$store.dispatch(AUser.GET_BANK_DETAILS);
                            }).catch(() => {
                                updateDetailsCtrl.bankDetailsUpdatedFail = true;

                                setTimeout(function () {
                                    updateDetailsCtrl.bankDetailsUpdatedFail = false;
                                }, 5000)
                            });
                        } else {
                            this.$store.dispatch(AUser.ADD_BANK_DETAILS, updateDetailsCtrl.newBankDetails).then(() => {
                                updateDetailsCtrl.bankDetailsUpdatedSuccess = true;
                                updateDetailsCtrl.step2FA = false;
                                clearInterval(this.interval);

                                setTimeout(function () {
                                    updateDetailsCtrl.bankDetailsUpdatedSuccess = false;
                                }, 5000);
                                updateDetailsCtrl.$store.dispatch(AUser.GET_BANK_DETAILS);
                            }).catch(() => {
                                updateDetailsCtrl.bankDetailsUpdatedFail = true;

                                setTimeout(function () {
                                    updateDetailsCtrl.bankDetailsUpdatedFail = false;
                                }, 5000)
                            });
                        }
                    } else {
                        updateDetailsCtrl.wrong2FA = true
                    }
                })
            },
            getCountries() {
                this.vin_countries = Object.keys(this.countries);
                this.vin_countries.forEach((code) => {
                    let allCountries = this.countries,
                        newCountry = {};
                    newCountry.id = parseInt(allCountries[code].id);
                    newCountry.code = code;
                    newCountry.value = allCountries[code].value;
                    this.countryMap.push(newCountry);
                })
            },
            resetBankDetails() {
                this.getData();
                this.showResetModal = false;
            },
            ...mapActions({
                getData: AUser.GET_BANK_DETAILS,
            }),
            updateSmsBoxes() {
                const fields = document.querySelectorAll(".sms-digit");

                function handleInputField({ target }) {
                    const value = target.value.slice(0, 1);
                    target.value = value;

                    const step = value ? 1 : -1;
                    const fieldIndex = [...fields].findIndex((field) => field === target);
                    const focusToIndex = fieldIndex + step;

                    if (focusToIndex < 0 || focusToIndex >= fields.length) return;

                    fields[focusToIndex].focus();
                }
                fields.forEach((field) => {
                    field.addEventListener("input", handleInputField);
                });
            },
            resendCode() {
                this.wrong2FA = false;
                this.$store.dispatch(AUser.GET_2FA_EMAIL).then(() => {
                    this.startTimer()
                })
            },
            startTimer() {
                this.countInProgress = true;
                this.timer = 120

                this.interval = setInterval(() => {
                    this.timer = this.timer - 1;

                    if (this.timer === 0) {
                        clearInterval(this.interval);
                        this.countInProgress = false;
                    }
                }, 1000);
            },
        },
        created() {
            this.$store.dispatch(AUser.GET_BANK_DETAILS);
            this.getCountries();
        }
    }
</script>

<style scoped>
    .bids-offers-modal {
        padding: 32px 48px;
        text-align: center;
        background: #f6f6f6;
    }
    .error-2fa {
        margin: 16px auto;
        color: #D5394F;
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .main .sms-submit {
        height: 49px;
        margin-top: 55px;
        padding: 16px;
        width: 100%;
        border-radius: 8px;
        background: #004F7F;
        border: 0;
    }
    .main {
        width: 375px;
        margin: 32px auto;
        justify-content: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 16px;
    }
    .sms-title {
        color: rgba(0, 0, 0, 0.88);
        text-align: center;
        align-self: stretch;
        font-family: Montserrat, sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-top: 16px;
    }
    .sms-subtitle {
        color: rgba(4, 1, 13, 0.60);
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
    }
    .sms-subtitle2 {
        color: rgba(4, 1, 13, 0.60);
        font-family: Montserrat, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px;
    }
    .fieldset {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        align-self: stretch;
    }
    .sms-digit {
        height: 48px;
        flex: 1 0 0;
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.64);
        text-align: center;
        color: #004F7F;
        font-family: Montserrat, sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .sms-digit-error {
        height: 48px;
        flex: 1 0 0;
        border-radius: 8px;
        border: 1px solid #ff0000;
        text-align: center;
        color: #ff0000;
        font-family: Montserrat, sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .countdown {
        padding: 16px;
        margin-top: 16px;
        color: rgba(0, 0, 0, 0.38);
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
    }
    .countdown2 {
        padding: 16px;
        margin-top: 16px;
        color: #004F7F;
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
    }
    .countdown2:hover {
        cursor: pointer;
    }
    .myprofile-label {
        position: absolute;
        font-size: 16px;
        color: #303030;
        font-weight: 300;
    }

    .myprofile-inner-container {
        max-width: 700px;
        background: #F5F6F5;
        border-radius: 10px;
        padding: 12px 0px 28px;
    }

    .submit {
        margin: 30px 0 50px 0;
        background: var(--blue) !important;
        color: #FFF !important;
        width: 200px;
        height: 40px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        letter-spacing: 0;
        font-weight: lighter;
        box-shadow: none;
    }

    .country-select {
        padding: 0;
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-bottom: 1px solid var(--light-gray);
        border-radius: 0;
        background-color: var(--true-white);
        margin: 0;
        height: 50px;
        margin-top: 50px;
        padding-left: 15px;
        color: #333333;
        font-family: var(--base-font);
        font-size: var(--fs-base);
        margin-bottom: 5px;
    }

    .country-select:hover {
        border-color: var(--brand);
        cursor: pointer;
    }

    .country-select:focus,
    .country-select:active {
        border-bottom: 2px solid #000000;
    }

    .country-select.error-msg {
        border-bottom: 1px solid red !important;
    }

    .country-label {
        margin-top: -30px;
    }

    .reset-btn {
        color: rgba(0, 0, 0, .64);
        width: 50px;
        display: inline-block;
        font-size: 19px;
        text-align: center;
        margin-top: 38px;
        margin-left: 32px;
        height: 23px;
        vertical-align: top;
    }

    .reset-btn .link-border {
        height: 1px;
        width: 100%;
        background: #707070;
    }

    .reset-btn:hover {
        color: var(--blue);
        cursor: pointer;
    }

    .reset-btn:hover .link-border {
        background: var(--blue);
    }

    .btn-reset-proceed {
        font-size: var(--fs-base);
        text-transform: initial;
        font-weight: 300;
        padding: 0 20px !important;
        background: var(--brand);
        color: #ffffff;
    }

    .btn-reset-cancel {
        font-size: var(--fs-base);
        text-transform: initial;
        font-weight: 300;
        padding: 0 20px !important;
    }

    .btn-reset-cancel:hover {
        color: #ffffff;
    }

    .reset-changes-modal {
        padding: 32px 48px;
        text-align: center;
    }

    .reset-changes-modal .warning-icon {
        background: url('../assets/report_problem-24px.svg') no-repeat center;
        background-size: contain;
        width: 40px;
        height: 40px;
        margin: 0 auto;
    }

    .reset-changes-body {
        text-align: center;
        justify-content: center;
        font-size: var(--fs-base);
    }

    .success-alert {
        background: #D4ECC9;
        border: 1px solid #A9DC8F;
        padding: 5px;
        text-align: center;
        color: #3B990D;
    }

    .fail-alert {
        background: #FF7F7F;
        border: 1px solid #FF0000;
        padding: 5px;
        text-align: center;
    }

    .bank-details-radio {
        margin-top: 0;
    }

    @media (max-width: 767px) {
        .myprofile-inner-container {
            padding: 12px;
            margin-top: 30px;
        }

        .submit {
            width: 100%;
        }
    }
</style>
<style>
    .main .sms-submit span {
        color: #FFF;
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
    }
    .myprofile-wrapper .bank-details-radio .v-input input {
        margin-top: 0;
    }

    .bank-details-radio .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
        margin-bottom: 0;
    }

    .bank-details-radio .v-text-field {
        padding-top: 0;
    }

    .myprofile-wrapper .myprofile-inner-container .bank-details-wrapper .v-text-field__details {
        display: flex;
    }

    .theme--light.v-text-field.v-input--has-state.error--text > .v-input__control > .v-input__slot:before {
        border-style: solid;
        border-width: thin 0 0;
    }

    .theme--light.v-text-field.v-input--has-state.error--text > .v-input__control > .v-input__slot input {
        border: 0;
    }
    .bids-offers-modal .v-card__title,
    .bids-offers-modal .v-card__actions {
        justify-content: center;
    }

    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__title{
        color: rgba(0, 0, 0, 0.88);
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding: 16px;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions {
        padding: 20px 16px 0;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-close {
        flex: 1 0 0;
        border-radius: 8px;
        border: 2px solid #004F7F;
        background: transparent;
        display: flex;
        padding: 16px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        margin-right: 0;
        height: 51px;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-close .v-btn__content {
        color: #004F7F;
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-proceed {
        border-radius: 8px;
        background: #004F7F;
        border: 2px solid #004F7F;
        display: flex;
        padding: 16px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        flex: 1 0 0;
        margin-left: 0;
        height: 51px;
    }
    .v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-proceed .v-btn__content {
        color: #FFF;
        text-align: center;
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: uppercase;
    }
</style>
